import React from 'react';
import PropTypes from 'prop-types';
import AlertFail from '@learningblocks/exp-constants/lib/Icons/alert-large-fail';
import AlertSuccess from '@learningblocks/exp-constants/lib/Icons/alert-large-success';
import CloseButton from '@learningblocks/exp-constants/lib/Icons/incorrect-relative';
import './style.scss';

const FEEDBACK_TYPE = {
  SUCCESS: {
    icon: AlertSuccess,
    message: "Let's do the experiment and see if our predictions match our results!",
  },
  FAIL: {
    icon: AlertFail,
    message: "Don't forget to drag all the bands!",
  },

  CORRECT_QUESTION_TABLE: {
    icon: AlertSuccess,
    message: "Feedback: Genotype prediction recorded!",
  },
  INCORRECT_QUESTION_TABLE: {
    icon: AlertFail,
    message: "Feedback: Incorrect! The genotype frequency can be calculated by dividing the number of students in the class with a given genotype by the total number of students in the class. Don’t forget to calculate this value for each listed genotype and round to two decimal places.",
  },

  INCOMPLETE_QUESTION_TABLE: {
    icon: AlertFail,
    message: "Do not forget to fill all available fields.",
  },


  CORRECT_PROTOCOL_QUESTION_TABLE: {
    icon: AlertSuccess,
    message: "Feedback: Correct! Nice work, you have entered the correct volumes of each reagent needed in each sample!",
  },
  INCORRECT_PROTOCOL_QUESTION_TABLE: {
    icon: AlertFail,
    message: "Feedback: Incorrect! You will need to mix 10uL of each PCR sample with 2uL of loading dye. You will then take 10uL of that mixture and load it onto the gel.",
  },

  INCORRECT_PROTOCOL_QUESTION_TABLE_2: {
    icon: AlertFail,
    message: "Feedback: Incorrect! You will need to mix 4uL of each PCR sample with 4uL of water and 2uL of loading dye.",
  },

  INCOMPLETE_PROTOCOL_QUESTION_TABLE: {
    icon: AlertFail,
    message: "Do not forget to fill all available fields.",
  },
}

export function Feedback(props) {
  const onClick = (event) => {
    event.preventDefault();
    props.onClose(event);
  };

  if (props.type) {
    const {icon, message} = FEEDBACK_TYPE[props.type];
    const iconClass = ['INCORRECT', 'INCOMPLETE', 'FAIL', 'INCORRECT_QUESTION_TABLE', 'INCOMPLETE_QUESTION_TABLE',
                      'INCORRECT_PROTOCOL_QUESTION_TABLE', 'INCOMPLETE_PROTOCOL_QUESTION_TABLE', 'INCORRECT_PROTOCOL_QUESTION_TABLE_2'].includes(props.type) ? 'FAIL' : 'SUCCESS'
    return (
      <div
        className={`geldragdropquestion_feedback ${iconClass.toLowerCase()}`}>
        {React.createElement(icon, {
          className: 'geldragdropquestion_feedback__icon',
        })}
        {React.createElement(
          'p',
          {className: 'geldragdropquestion_feedback__message'},
          message
        )}
        <CloseButton
          className='geldragdropquestion_feedback__close'
          onClick={onClick}
        />
      </div>
    );
  } else {
    return null;
  }
}

Feedback.propTypes = {
  /**
   * Type of Feedback to display [if dype id null will not show feedback]
   */
  type: null || PropTypes.oneOf(['SUCCESS', 'FAIL']),
  /**
   * Function to invoke on click of close button
   */
  onClose: PropTypes.func,
};

Feedback.defaultProps = {
  type: null,
};
